import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { IconButton, Drawer as MuiDrawer, Stack } from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  Menu as MenuIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { NewSideBarList } from './NewSideBarList';
import { SideBarButton } from './SideBarButton';
import { ConfirmationModal } from '../Modal/ConfirmationModal';
import { apiUrl } from '../../utilities/apiUrl';
import logo from '../../assets/images/logo_white.png';
import '../../css/SideBar.css';

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export const NewSideBar = (props) => {
  const [open, setOpen] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogoutOpen = () => {
    setLogoutOpen(true);
  };

  const handleLogoutClose = () => {
    setLogoutOpen(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();

    fetch(apiUrl('/auth/logout'), {
      method: 'POST',
      credentials: 'include',
    })
      .then((response) => {
        window.location.replace('/');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Drawer
        variant="permanent"
        open={open}
        sx={{ bgcolor: 'palette.primary', my: '28px' }}
      >
        <DrawerHeader
          sx={{ justifyContent: open ? 'flex-end' : 'center', my: 3 }}
        >
          <img
            src={logo}
            style={{ display: open ? 'flex' : 'none', margin: 'auto' }}
            width="65%"
            alt="i-Bridge Logo"
          />
          <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </DrawerHeader>
        <NewSideBarList open={open} selectedPage={props.selectedPage} />
        <Stack
          direction="column"
          sx={{ marginTop: 'auto', marginBottom: '16px', mx: '0' }}
        >
          <SideBarButton
            open={open}
            iconName={<LogoutIcon style={{ fill: 'white', m: 'auto' }} />}
            btnName="Logout"
            clickHandler={handleLogoutOpen}
            mode={props.mode}
          />
        </Stack>
      </Drawer>
      <ConfirmationModal
        open={logoutOpen}
        onClose={handleLogoutClose}
        primaryClickHandler={handleLogout}
        secondaryClickHandler={handleLogoutClose}
        title={'Logout'}
        desc={'Are you sure you want to logout?'}
        primaryBtnName={'Logout'}
        secondaryBtnName={'Cancel'}
      />
    </>
  );
};
